import { CreateRoleRequest } from "@Types/roles";

export const initialRoleState: CreateRoleRequest = {
  data: {
    info: {
      name: "",
      permissions: {
        dealership: {
          page: "dealership",
          label: "Dealer",
          description: "Pages related to dealers.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
          subPages: [],
        },
        deal: {
          page: "deal",
          label: "Loans",
          description: "Pages related to loans.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
          subPages: [
            {
              page: "collateral",
              hasPermissions: false,
            },
            {
              page: "trade-in",
              hasPermissions: false,
            },
            {
              page: "applicants",
              hasPermissions: false,
            },
            {
              page: "financials",
              isSensitive: true,
              hasPermissions: false,
            },
          ],
        },
        lender_user: {
          page: "lender_user",
          description: "Pages related to the app users.",
          label: "Users",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
        },
        lender_role: {
          label: "Roles",
          page: "lender_role",
          description: "Pages related to permission roles.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
        },
        lender_team: {
          label: "Teams",
          page: "lender_team",
          description: "Pages related to permissions teams.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
        },
        lender_ticket: {
          label: "Lender tickets",
          page: "lender_ticket",
          description: "Lender tickets.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
        },
        title_info: {
          label: "Title information",
          page: "title_info",
          description: "Pages related to  Title information.",
          permissions: {
            owner: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            group: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
            other: {
              read: {
                hasPermissions: false,
              },
              update: {
                hasPermissions: false,
              },
              create: {
                hasPermissions: false,
              },
              delete: {
                hasPermissions: false,
              },
            },
          },
        },
      },
    },
  },
};
